export interface CounterInfo {
    counterName: string,
    counterPreText: string,
    counterValue: number
}

export const _defaultCounterInfo = {
    counterName: "",
    counterPreText: "",
    counterValue: 0
}